export const isOnfidoCountry = (country: string) =>
  !['SE', 'NO', 'FI', 'DK', 'NL'].includes(country);
